module.exports = __webpack_public_path__ + "static/media/vietnam.8151b79e.svg";